<template>
    <div class="table-action-cell" :class="grid">
        <a :href="url" :target="target">
            <div class="table-action-cell__icon-wrapper">
                <slot></slot>
            </div>
            <div class="table-action-cell__label">{{label}}</div>
        </a>
    </div>
</template>

<script>
    export default {
        props: {
            'url':'',
            'label':'',
            'target' : '',
            'grid':{
                default: 'table-action-cell--grid-1of3'
            }
        }
    }
</script>
